import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
} from '@angular/core';

@Component({
  selector: 'app-horizontal-navigation',
  templateUrl: './horizontal-navigation.component.html',
  styleUrls: ['./horizontal-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalNavigationComponent {
  @ViewChild('content', { static: true }) content: ElementRef<HTMLElement>;

  scrollLeft(): void {
    this.content.nativeElement.scrollTo({
      left: this.content.nativeElement.scrollLeft - 150,
      behavior: 'smooth',
    });
  }

  scrollRight(): void {
    this.content.nativeElement.scrollTo({
      left: this.content.nativeElement.scrollLeft + 150,
      behavior: 'smooth',
    });
  }

  // Trigger the change detection of ng-content
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  observeContentChange(): void {}
}
